// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3usoM","largestCol":"styles_largestCol__1qjtT","smallestCol":"styles_smallestCol__1nc-i"};